<template>
    <div class="tabsContainer">
        <b-nav class="tabs">
            <b-nav-item id="tab-login"
                class="tab"
                to="login">
                {{ $t('actions.login') }}
            </b-nav-item>
            <b-nav-item active
                id="tab-register"
                class="tab"
                to="register">
                {{ $t('actions.register') }}
            </b-nav-item>
        </b-nav>
    </div>
</template>

<script>
export default {
    name: 'TabsMenu',
    props: {}
}
</script>
